/**
 * Data layer for `igaming-gdpr-regional-data-residency-for-igaming-t`. Thin typed fetch wrappers over /api/v1/igaming-gdpr-regional-data-residency-for-igaming-t.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingGdprRegionalDataResidencyForIgamingTRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingGdprRegionalDataResidencyForIgamingTResponse {
	count: number;
	items: IgamingGdprRegionalDataResidencyForIgamingTRow[];
}

export interface CreateIgamingGdprRegionalDataResidencyForIgamingTBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-gdpr-regional-data-residency-for-igaming-t";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingGdprRegionalDataResidencyForIgamingTResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingGdprRegionalDataResidencyForIgamingTResponse>(res);
}

export async function create(body: CreateIgamingGdprRegionalDataResidencyForIgamingTBody): Promise<IgamingGdprRegionalDataResidencyForIgamingTRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingGdprRegionalDataResidencyForIgamingTRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingGdprRegionalDataResidencyForIgamingTQueryKeys = {
	all: ["igaming-gdpr-regional-data-residency-for-igaming-t"] as const,
	list: () => [...igamingGdprRegionalDataResidencyForIgamingTQueryKeys.all] as const,
	detail: (id: string) => [...igamingGdprRegionalDataResidencyForIgamingTQueryKeys.all, id] as const,
};
